export async function loadQrScanner(
	importer: () => Promise<{ default?: unknown } | unknown> = () => import('react-qr-scanner')
): Promise<{ Reader: unknown; error: Error | null }> {
	try {
		const mod = await importer()
		const Reader = (mod as { default?: unknown })?.default ?? mod
		if (!Reader) throw new Error('QR scanner missing')
		return { Reader, error: null }
	} catch (caught) {
		const error = caught instanceof Error ? caught : new Error('QR scanner failed to load')
		return { Reader: null, error }
	}
}
